class FrequentlyBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.showCart = true;

    this.freqBoughtInputElements = this.querySelectorAll(
      ".frequently-bought__input",
    );
    this.freqBoughtAtcButton = this.querySelector(
      ".frequently-bought__atc-button",
    );
    this.freqBoughtTotalPriceElemet = this.freqBoughtAtcButton.querySelector(
      ".frequently-bought__total-price",
    );
    this.freqBoughtFinalPriceElement = this.freqBoughtAtcButton.querySelector(
      ".frequently-bought__final-price",
    );

    this.freqBoughtInputElements.forEach((productInput) => {
      productInput.addEventListener("change", this.onInputChange.bind(this));
    });
    this.freqBoughtAtcButton.addEventListener(
      "click",
      this.addFreqBoughtProductsToCart.bind(this),
    );
  }

  getSelectedProducts() {
    const selectedProducts = Array.from(this.freqBoughtInputElements).filter(
      (inputElement) => inputElement.checked,
    );

    return selectedProducts;
  }

  onInputChange(e) {
    const selectedProducts = this.getSelectedProducts();

    const totalPrice = selectedProducts.reduce(
      (acc, product) => acc + parseInt(product.dataset.productPrice),
      0,
    );

    if (selectedProducts.length === this.freqBoughtInputElements.length) {
      this.freqBoughtTotalPriceElemet.textContent = `Rs. ${this.freqBoughtTotalPriceElemet.dataset.totalPrice}`;
      this.freqBoughtFinalPriceElement.textContent = `Rs. ${this.freqBoughtFinalPriceElement.dataset.finalPrice}`;
      this.freqBoughtTotalPriceElemet.classList.add("strikethrough");
      this.freqBoughtTotalPriceElemet.classList.add("total-price");
      this.freqBoughtFinalPriceElement.classList.remove("hide-element");
      this.freqBoughtAtcButton.removeAttribute("disabled", false);
    } else if (selectedProducts.length === 0) {
      this.freqBoughtTotalPriceElemet.textContent = "Rs. 0";
      this.freqBoughtTotalPriceElemet.classList.remove("total-price");
      this.freqBoughtFinalPriceElement.classList.add("hide-element");
      this.freqBoughtAtcButton.setAttribute("disabled", true);
    } else {
      this.freqBoughtTotalPriceElemet.textContent = `Rs. ${totalPrice}`;
      this.freqBoughtTotalPriceElemet.classList.remove("strikethrough");
      this.freqBoughtTotalPriceElemet.classList.remove("total-price");
      this.freqBoughtFinalPriceElement.classList.add("hide-element");
      this.freqBoughtAtcButton.removeAttribute("disabled", false);
    }
  }

  addFreqBoughtProductsToCart() {
    const selectedProducts = this.getSelectedProducts();

    let items = [];
    for (const product of selectedProducts) {
      items.push({ id: product.dataset.productId, quantity: 1 });
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";

    const freqBoughtData = { items: items };

    if (this.cart) {
      freqBoughtData["sections"] = this.cart
        .getSectionsToRender()
        .map((section) => section.id);
      freqBoughtData["sections_url"] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(freqBoughtData);

    fetch("/cart/add.js", config)
      .then((response) => response.json())
      .then((data) => {
        this.cart.renderContents(data, this.showCart);
        this.cart.addFreebie();
        this.cart.open();
        this.addDatalayerEvents();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
      });
  }

  addDatalayerEvents() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        console.log(data);

        const productsData = [];
        const productQuantityArray = [];
        const productNameArray = [];
        const productSkuArray = [];
        const productRetailPriceArray = [];
        const productMrpPriceArray = [];
        const productImageUrlArray = [];
        const productUrlArray = [];

        data.items.forEach((product) => {
          productsData.push({
            id: product.id,
            name: product.title,
            price: Math.round(product.price / 100),
            quantity: 1,
          });

          productQuantityArray.push(1);
          productNameArray.push(product.title);
          productSkuArray.push(product.sku);
          productRetailPriceArray.push(Math.round(product.price / 100));
          productMrpPriceArray.push(
            Math.round(product.productMrpPriceList / 100),
          );
          productImageUrlArray.push(product.image);
          productUrlArray.push(product.url);
        });

        const clevertapData = {
          productQuantity: productQuantityArray.join(","),
          productName: productNameArray.join(","),
          productSku: productSkuArray.join(","),
          productRetailPrice: productRetailPriceArray.join(","),
          productMrpPrice: productMrpPriceArray.join(","),
          productImageUrl: productImageUrlArray.join(","),
          productUrl: productUrlArray.join(","),
        };

        dataLayer.push({
          event: "frequently bought add to cart",
          ecommerce: {
            currencyCode: data.currency,
            add: {
              products: productsData,
              subTotal: Math.round(data.total_price / 100),
              totalQuantity: data.items.length,
            },
          },
          clevertap: clevertapData,
        });
      });
  }
}

customElements.define("frequently-bought-together", FrequentlyBoughtTogether);